export function getIdSelector(id) {
  return `#${id}`;
}

export function getDistance(distance, x, y, prevX, prevY) {
  const distanceX = Math.abs(x - prevX);
  const distanceY = Math.abs(y - prevY);
  return distance + Math.sqrt(distanceX * distanceX + distanceY * distanceY);
}

export function getUrl(id) {
  return `url(#${id})`;
}
